const baseUrl = "https://us-central1-labenu-apis.cloudfunctions.net/labeX/matheus-souza-shaw"

export default baseUrl